// extracted by mini-css-extract-plugin
export var cardLayout = "_6n-1";
export var paginationContainer = "_6n-0";